import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMissingAccountExternalIdRedirect } from "@hooks";
import AcceptLiftLoanWrapper from "./AcceptLiftLoan.styles";
import { Paragraph } from "@components/paragraph";
import { PageWrapper } from "@containers/PageWrapper/pageWrapper";
import { Paper } from "@components/paper";
import SectionHeading from "../../components/sectionHeading";
import { Loader } from "../../components/loader/loader";
import actions from "@redux/acceptLiftLoan/actions"
import environmentSettings from "@src/constants/environmentSettings";

export const AcceptLiftLoan = () => {
    const { hasAccepted, acceptFailed } = useSelector(state => state.acceptLiftLoan);
    const dispatch = useDispatch();

    const { phone } = environmentSettings;

    useMissingAccountExternalIdRedirect({
        onMountWithId: (accountExternalId) => {
            dispatch(actions.submitAcceptLiftLoan({accountExternalId}));
        }
    });
        
    const FailedLiftLoan = () => (
        <PageWrapper>
            <Paper>
                <AcceptLiftLoanWrapper maxWidth="720px">
                    <SectionHeading heading="An issue has occurred"/>
                    <Paragraph size="p0" textAlign="center">
                        Apologies, there is an issue accepting your Lift Loan. Please check your link is valid and try again.
                    </Paragraph>
                    <Paragraph size="p0" textAlign="center">
                        If you need any assistance, please call us on <a href={`tel:${phone}`}>{phone}</a>.
                    </Paragraph>
                </AcceptLiftLoanWrapper>
            </Paper>
        </PageWrapper>
    )

    const SuccessLiftLoan = () => (
        <PageWrapper>
            <Paper>
                <AcceptLiftLoanWrapper maxWidth="720px">
                    <SectionHeading heading="Thank you for proceeding with your Lift Loan Offer!"/>
                    <Paragraph size="p0" textAlign="center">
                        Your updated Lift Loan contract is being prepared and will be emailed to you shortly!
                    </Paragraph>
                    <Paragraph size="p0" textAlign="center">
                    <strong>Your final step is to:</strong><br />
                    open and view your contract &amp;<br />
                    electronically sign it
                    </Paragraph>
                    <Paragraph size="p0" textAlign="center">
                    To do this, simply enter the SECURITY CODE we have sent to your mobile number.
                    </Paragraph>
                    <Paragraph size="p0" textAlign="center">
                    Once electronically signed, your loan funds will be transferred to your account!
                    </Paragraph>
                    <Paragraph size="p0" textAlign="center">
                    If you need any assistance, please call us on <a href={`tel:${phone}`}>{phone}</a>.
                    <br />
                    Go forward with us!
                    </Paragraph>
                </AcceptLiftLoanWrapper>
            </Paper>
        </PageWrapper>
    );

    const RenderLiftLoan = () => {
        if(acceptFailed) {
            return <FailedLiftLoan />
        }
        if(hasAccepted) {
            return <SuccessLiftLoan />
        }
        return  <Loader />
    } 

    return (
        <RenderLiftLoan />
    );
}
